import { render } from "./sysinfo.vue?vue&type=template&id=1e36a688"
import script from "./sysinfo.vue?vue&type=script&lang=js"
export * from "./sysinfo.vue?vue&type=script&lang=js"

import "./sysinfo.vue?vue&type=style&index=0&id=1e36a688&lang=less"

import exportComponent from "D:\\work\\web\\sal_appgd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__